import React, { useState, useCallback, useEffect } from 'react'
import { Autocomplete } from 'components/Autocomplete'
import { useSelector } from 'react-redux'
import { useUsuarioService } from 'hooks/useUsuarioService'
import { TextField, Checkbox } from '@material-ui/core'

import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

export const SelectUsuarios = (props) => {
  const usuarioService = useUsuarioService()
  const usuarios = useSelector((state) => state.options.usuarios)
  const { usuariosExternos, setUsuariosExternos, setProcessando, label, isFromBanco, multiplo } = props
  const [listaOpcoesUsuariosFiltros, setListaOpcoesUsuariosFiltrados] = useState([])
  const [inputUsuario, setInputUsuario] = useState(null)

  const fetchUsuarios = useCallback(() => {
    /* Se o select pertencer a uma pagina de banco eu listo todos os usuarios incluindo os FAKE */
    if (isFromBanco) {
      usuarioService.listarTodosOsUsuarios(setProcessando)
    } else {
      usuarioService.listarUsuarios(setProcessando)
    }
  }, [])

  useEffect(() => {
    fetchUsuarios()
  }, [fetchUsuarios])

  return (
    <Autocomplete
      value={usuariosExternos}
      multiple={multiplo}
      name="usuarios"
      options={usuarios || []}
      onChange={(event, newValue) => {
        setUsuariosExternos(newValue)
      }}
      getOptionLabel={(option) => `${option?.nome} ${option.cargo ? ` - ${option.cargo.nome}`.toUpperCase() : ''}`}
      getTagLabel={(option) => option.nome}
      getTagTooltip={(option) => `${option?.nome} ${option.cargo ? ` - ${option.cargo.nome}`.toUpperCase() : ''}`}
      label={label || 'Usuários'}
    />
  )
}
